import Button from '@components/std-components/Button'
import { useObserver } from 'mobx-react-lite'
import React, { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'
import Icon from '@components/std-components/Icons'
import { Tooltip, makeStyles } from '@material-ui/core'
import { CopyTemplateImg, PasteTemplateImg } from '@resources/images'
import classNames from 'classnames'

interface ITemplateCopyPasteButtons {
  disableCopyTemplate: boolean
  disablePasteFromTemplate: boolean
  setShowSaveCopyTemplate: (value: boolean) => void
  setShowCopiedTemplates: (value: boolean) => void
}
const useStyles = makeStyles(() => ({
  btn: {
    padding: '0 5px 0',
    '& .icon': {
      cursor: 'inherit'
    }
  },
  disabledBtn: {
    opacity: 0.5,
    cursor: 'not-allowed'
  }
}))

const TemplateCopyPasteButtons: FC<ITemplateCopyPasteButtons> = ({
  disableCopyTemplate,
  disablePasteFromTemplate,
  setShowSaveCopyTemplate,
  setShowCopiedTemplates
}) =>
  useObserver(function useHook() {
    const classes = useStyles()
    const { t } = useTranslation()
    return (
      <>
        <div>
          <Button
            onClick={() => {
              if (disableCopyTemplate) {
                return
              }
              setShowSaveCopyTemplate(true)
            }}
            disabled={disableCopyTemplate}
            variant='link'
            size='none'
            className={classNames(classes.btn, {
              [classes.disabledBtn]: disableCopyTemplate
            })}
          >
            <Tooltip
              title={t('order.quantitiesAndBook.copyToTemplate', 'Copy As Template')}
            >
              <div>
                <Icon imageSrc={CopyTemplateImg} alt={'copyTemplate'} />
              </div>
            </Tooltip>
          </Button>
        </div>
        <div>
          <Button
            onClick={() => {
              if (disablePasteFromTemplate) {
                return
              }
              setShowCopiedTemplates(true)
            }}
            disabled={disablePasteFromTemplate}
            size='none'
            variant='link'
            className={classNames(classes.btn, {
              [classes.disabledBtn]: disablePasteFromTemplate
            })}
          >
            <Tooltip
              title={t(
                'order.quantitiesAndBook.pasteFromTemplate',
                'Paste From Template'
              )}
            >
              <div>
                <Icon imageSrc={PasteTemplateImg} alt={'pasteTemplate'} />
              </div>
            </Tooltip>
          </Button>
        </div>
      </>
    )
  })

export default memo(TemplateCopyPasteButtons)
